(() => {
  const attribute = 'tibhelper_offer_source';
  const source = 'founderbonus-guide-v1';
  const productId = '9932647629079';
  const root = window.Shopify?.routes?.root || '/';
  const boot = document.getElementById('TibhelperFounderBonusScript');
  let marked = boot?.dataset.source === source;
  let changing = false;
  let cleaning = false;

  async function cart() {
    const response = await fetch(`${root}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart');
    const result = await response.json();
    if (!Array.isArray(result.items)) throw new Error('cart');
    return result;
  }

  function containsTibhelper(value) {
    return value.items.some(item => String(item.product_id) === productId ||
      item.item_components?.some(component => String(component.product_id) === productId));
  }

  async function writeSource(value) {
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [attribute]: value } })
    });
    const result = await response.json();
    if (!response.ok || result.status || result.errors || (value && result.attributes?.[attribute] !== value)) throw new Error('attribute');
    return result;
  }

  async function clearUnusedSource() {
    if (!marked || cleaning || changing || window.TibhelperCartUpgradeBusy) return;
    cleaning = true;
    try {
      const current = await cart();
      if (current.attributes?.[attribute] !== source) { marked = false; return; }
      if (!containsTibhelper(current)) { await writeSource(''); marked = false; }
    } catch {} finally { cleaning = false; }
  }

  if (!customElements.get('tibhelper-founder-bonus')) {
    customElements.define('tibhelper-founder-bonus', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.button = this.querySelector('button[type="submit"]');
        this.status = this.querySelector('[role="status"]');
        this.review = this.querySelector('.tfb__review');
        this.initialLabel = this.button.textContent;
        this.button.disabled = !this.form.querySelector('[name="id"]:checked:not(:disabled)');
        this.form.addEventListener('change', () => {
          if (!this.added && !this.needsReview && !changing) this.button.disabled = !this.form.querySelector('[name="id"]:checked:not(:disabled)');
        });
        this.form.addEventListener('submit', event => { event.preventDefault(); this.add(); });
      }

      async add() {
        if (this.needsReview || changing || cleaning || window.TibhelperCartUpgradeBusy || !this.form.reportValidity()) return;
        changing = true;
        this.button.disabled = true;
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.busy;
        let uncertain = false;
        try {
          if (!this.added) {
            let response;
            try {
              response = await fetch(`${root}cart/add.js`, {
                method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form)
              });
            } catch (error) { uncertain = true; throw error; }
            let result;
            try { result = await response.json(); } catch (error) { uncertain = true; throw error; }
            if (!response.ok || result.status || result.errors) {
              uncertain = response.status >= 500;
              throw new Error('add');
            }
            this.added = true;
            this.form.querySelectorAll('[name="id"]').forEach(input => { input.disabled = true; });
          }
          const before = await cart();
          if (!containsTibhelper(before)) throw new Error('missing');
          const result = await writeSource(source);
          marked = true;
          if (!containsTibhelper(result)) {
            await writeSource('');
            marked = false;
            throw new Error('missing');
          }
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.review.hidden = false;
          if (uncertain || error.message === 'missing') {
            this.needsReview = true;
            this.status.textContent = this.dataset.uncertain;
          } else if (this.added) {
            this.status.textContent = this.dataset.attributionError;
            this.button.textContent = this.dataset.retry;
            this.button.disabled = false;
          } else {
            this.status.textContent = this.dataset.error;
            this.button.disabled = false;
          }
        } finally {
          changing = false;
          this.removeAttribute('aria-busy');
        }
      }
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, clearUnusedSource);
  }
  window.addEventListener('pageshow', clearUnusedSource);
  clearUnusedSource();
})();
